var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-footer"},[_c('div',{staticClass:"page-footer-inner"},[_vm._v(" 2020 © Metronic by keenthemes. ")]),_c('div',{staticClass:"page-footer-tools"},[_c('span',{staticClass:"go-top"},[_c('i',{staticClass:"fa fa-angle-up"})])])])
}]

export { render, staticRenderFns }